<template>
  <div>
    <v-layout row wrap>
      <v-flex xs6>
        <v-flex>
          <v-layout row align-center>
            <v-card
              height="15px"
              width="15px"
              color="green lighten-2"
            ></v-card>
            <v-flex>
              <div class="pl-4 body-2 font-weight-bold">
                <v-layout row wrap>
                  <v-flex xs7><div class="grey--text font-weight-light text--darken-3">{{ $t("screener.seats.status.selected.title") }}</div></v-flex>
                  <v-flex xs5><div class="grey--text text--darken-3">{{selectedSeats.length}}</div></v-flex>
                </v-layout>
              </div>
             </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row align-center>
            <v-card
              height="15px"
              width="15px"
              :color="
                DEFINES.SEATS_CATEGORIES[
                  DEFINES.SEAT_CATEGORIES_VALUE.REGULAR
                ].color
              "
            ></v-card>
            <v-flex>
            <div class="pl-4 body-2 font-weight-bold">
              <v-layout row align-center>
                <v-flex xs7> 
                  <div class="grey--text font-weight-light text--darken-3">{{
                    DEFINES.SEATS_CATEGORIES[
                      DEFINES.SEAT_CATEGORIES_VALUE.REGULAR
                    ].label
                  }}</div></v-flex>
                <v-flex xs5>
                  <div class="grey--text text--darken-3">{{seat_counts[DEFINES.SEAT_CATEGORIES_VALUE['REGULAR']]}}</div>
                </v-flex>
              </v-layout>
            </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row align-center>
            <v-card
              height="15px"
              width="15px"
              :color="
                DEFINES.SEATS_CATEGORIES[
                  DEFINES.SEAT_CATEGORIES_VALUE.CHEAPER
                ].color
              "
            ></v-card>
            <v-flex>
              <div class="pl-4 body-2 font-weight-bold">
                <v-layout row align-center>
                  <v-flex xs7> 
                    <div class="grey--text font-weight-medium text--darken-3">{{
                      DEFINES.SEATS_CATEGORIES[
                        DEFINES.SEAT_CATEGORIES_VALUE.CHEAPER
                      ].label
                    }}</div>
                  </v-flex>
                  <v-flex xs5>
                    <div class="grey--text text--darken-3">{{seat_counts[DEFINES.SEAT_CATEGORIES_VALUE['CHEAPER']]}}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex xs6>
        <v-flex >
          <v-layout row align-center>
            <v-card
              height="15px"
              width="15px"
              :color="
                DEFINES.SEATS_CATEGORIES[
                  DEFINES.SEAT_CATEGORIES_VALUE.PREMIUM
                ].color
              "
            ></v-card>
            <v-flex>
              <div class="pl-4 body-2 font-weight-bold">
                <v-layout row align-center>
                  <v-flex xs7>
                    <div class="grey--text font-weight-light text--darken-3">{{
                      DEFINES.SEATS_CATEGORIES[
                        DEFINES.SEAT_CATEGORIES_VALUE.PREMIUM
                      ].label
                    }}</div>
                  </v-flex>
                <v-flex xs5>
                  <div class="grey--text text--darken-3">{{seat_counts[DEFINES.SEAT_CATEGORIES_VALUE['PREMIUM']]}}</div>
                </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex >
          <v-layout row align-center>
            <v-card
              height="15px"
              width="15px"
              :color="
                DEFINES.SEATS_CATEGORIES[
                  DEFINES.SEAT_CATEGORIES_VALUE.DISABLED
                ].color
              "
            ></v-card>
            <v-flex>
            <div class="pl-4 body-2 font-weight-bold">
              <v-layout row align-center>
                <v-flex xs7>
                  <div class="grey--text font-weight-light text--darken-3">{{
                    DEFINES.SEATS_CATEGORIES[
                      DEFINES.SEAT_CATEGORIES_VALUE.DISABLED
                    ].label
                  }}</div>
                </v-flex>
                <v-flex xs5>
                  <div class="grey--text text--darken-3">{{seat_counts[DEFINES.SEAT_CATEGORIES_VALUE['DISABLED']]}}</div>
                </v-flex>
              </v-layout>
            </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row align-center>
            <v-card
              height="15px"
              width="15px"
              color="grey darken-2"
            ></v-card>
            <v-flex>
              <div class="pl-4 body-2 font-weight-bold">
                <v-layout row align-center>
                  <v-flex xs7>
                    <div class="grey--text font-weight-light text--darken-3">{{ $t("venue.seat.context.menu.mark.not_available.title") }}</div>
                  </v-flex>
                  <v-flex xs5>
                    <div v-if="venue && venue.not_for_sale" class="grey--text text--darken-3 not_for_sale">{{venue.not_for_sale.length}}</div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: "SeatTypeLabels",
  props: {
    venue: {
      type: Object,
      default: null,
    },
    selectedSeats: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      seat_counts: {
        10: 0,
        20: 0,
        30: 0,
        40: 0
      }
    }
  },
  computed: {
    seats() {
     return this.venue ?  this.venue.seats : {} ;
    },
  },
  watch:{
    venue:{
        deep:true,
        handler:function(){
            if(!this.venue){
                return;
            }
            this.countSeats()
        }
    },
  },
  mounted() {
    this.countSeats()
  },
  methods: {
    countSeats() {
      this.seat_counts = { 10: 0, 20: 0, 30: 0,40: 0}
      Object.keys(this.seats).filter((key) => {
           if(this.seats[key].is_accessible){
             this.seat_counts[this.seats[key]["category"]] += 1
           }
          });
        }
    }
};
</script>
<style scoped>
.not_for_sale{
  line-height: 90%;
  margin-top: 9px;
}
</style>